module.exports = __webpack_public_path__ + "img/gift4-01-c04-k2.c005d139.png";